import { Breadcrumb, Page } from "@eisox/design-system";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

import { useAirHandlerUnitContext } from "~/features/air-handler-unit";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute(
  "/_authenticated/buildings_/$buildingId/air-handler-units/$airHandlerUnitId/settings",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { buildingId, airHandlerUnitId } = Route.useParams();
  const { name, floors, airHandlerUnit } = useAirHandlerUnitContext(Route.id);

  const displayFreeCooling = airHandlerUnit[0]?.freeCooling !== undefined;

  return (
    <Page.Root>
      <Page.Header>
        <Breadcrumb.Root>
          <Breadcrumb.List>
            {floors.length > 0 && (
              <>
                <Breadcrumb.Item>
                  <Breadcrumb.Link asChild>
                    {floors.length > 1 ? (
                      <div>
                        {floors.map(floor => (
                          <Link
                            key={floor.id}
                            to={"/buildings/$buildingId/floors/$floorId"}
                            params={{ buildingId, floorId: floor.id }}
                          >
                            {floor.name}
                          </Link>
                        ))}
                      </div>
                    ) : (
                      <Link
                        to={"/buildings/$buildingId/floors/$floorId"}
                        params={{ buildingId, floorId: floors[0]?.id ?? "" }}
                      >
                        {floors[0]?.name}
                      </Link>
                    )}
                  </Breadcrumb.Link>
                </Breadcrumb.Item>
                <Breadcrumb.Separator />
              </>
            )}
            <Breadcrumb.Item>
              <Breadcrumb.Link asChild>
                <Link
                  to={"/buildings/$buildingId/air-handler-units/$airHandlerUnitId"}
                  params={{ buildingId, airHandlerUnitId }}
                >
                  {name}
                </Link>
              </Breadcrumb.Link>
            </Breadcrumb.Item>
            <Breadcrumb.Separator />
            <Breadcrumb.Item>
              <Breadcrumb.Page asChild>
                <Page.Title>{m.settings()}</Page.Title>
              </Breadcrumb.Page>
            </Breadcrumb.Item>
          </Breadcrumb.List>
        </Breadcrumb.Root>
      </Page.Header>
      <Page.Content className="mr-0 gap-10 p-10 flex text-base" data-testid="BMSAirHandlerUnitSettings">
        <div className="pr-10 gap-2.5 flex w-fit flex-col">
          <Link
            activeProps={{ className: "text-primary-blue" }}
            to={"/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/general"}
            params={{ buildingId, airHandlerUnitId }}
          >
            {m.general()}
          </Link>
          <Link
            activeProps={{ className: "text-primary-blue" }}
            to={"/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/setpoint"}
            params={{ buildingId, airHandlerUnitId }}
          >
            {m.setpoint()}
          </Link>
          <Link
            activeProps={{ className: "text-primary-blue" }}
            to={"/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/planning"}
            params={{ buildingId, airHandlerUnitId }}
          >
            {m.planning()}
          </Link>
          {displayFreeCooling && (
            <Link
              activeProps={{ className: "text-primary-blue" }}
              to={"/buildings/$buildingId/air-handler-units/$airHandlerUnitId/settings/free-cooling"}
              params={{ buildingId, airHandlerUnitId }}
            >
              {m.free_cooling()}
            </Link>
          )}
        </div>
        <div className="flex-1">
          <Outlet />
        </div>
      </Page.Content>
    </Page.Root>
  );
}
